export const UPDATE_SCORE = "UPDATE_SCORE";
export const GAME_OVER = "GAME_OVER";
export const CHECK_COLLISION = "CHECK_COLLISION";
export const MOVE_PLAYER_DOWN = "MOVE_PLAYER_DOWN";
export const MOVE_PLAYER_LEFT = "MOVE_PLAYER_LEFT";
export const MOVE_PLAYER_RIGHT = "MOVE_PLAYER_RIGHT";
export const MOVE_PLAYER_UP = "MOVE_PLAYER_UP";
export const SHOOT = "SHOOT";
export const START_GAME = "START_GAME";
export const TOGGLE_START_BUTTON = "TOGGLE_START_BUTTON";
export const IS_START_BUTTON_VISIBLE = "IS_START_BUTTON_VISIBLE";
export const SAVE_GAME_STATE = "SAVE_GAME_STATE";
export const OPEN_POPUP = "OPEN_POPUP";
export const CLOSE_POPUP = "CLOSE_POPUP";
export const GAME_WON = "GAME_WON";
export const CHECK_ENTRANCE_COLLISION = "CHECK_ENTRANCE_COLLISION";
export const UPDATE_COUNTDOWN = "UPDATE_COUNTDOWN";
export const DECREASE_LIVES = "DECREASE_LIVES";
export const CHECK_ENEMY_PAST_BOTTOM = "CHECK_ENEMY_PAST_BOTTOM";
export const GAME_DONE = "GAME_DONE";
export const BACK_TO_MAIN_MENU = "BACK_TO_MAIN_MENU";
export const REPLAY_GAME = "REPLAY_GAME";
export const PAUSE_GAME = "PAUSE_GAME";
export const TOGGLE_PAUSE_MESSAGE = "TOGGLE_PAUSE_MESSAGE";
export const GAME_TIMEOUT = "GAME_TIMEOUT";
export const RESET_GAME = "RESET_GAME";




